import { render, staticRenderFns } from "./DashboardFooter.vue?vue&type=template&id=1fea3590&"
import script from "./DashboardFooter.vue?vue&type=script&lang=js&"
export * from "./DashboardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports